/**
 * Sincronização de autenticação entre abas via BroadcastChannel API (REQ-003 / AB#25).
 *
 * Uma aba que faz LOGOUT publica { type: 'LOGOUT' } no canal 'auth'; outras abas
 * abertas escutam e encerram a sessão local. A mensagem LOGIN é opcional e fica
 * disponível para futuras telas que precisem revalidar o estado.
 */

export type AuthBroadcastMessage = { type: 'LOGIN' | 'LOGOUT' };

const CHANNEL = 'auth';

/** Publica uma mensagem no canal 'auth'. No-op em ambientes sem BroadcastChannel. */
export function broadcastAuth(type: AuthBroadcastMessage['type']): void {
  if (typeof BroadcastChannel === 'undefined') return;
  try {
    const ch = new BroadcastChannel(CHANNEL);
    ch.postMessage({ type });
    ch.close();
  } catch {
    // ignora silenciosamente — ambiente sem suporte (SSR/browser antigo)
  }
}

/** Inscreve um listener no canal 'auth'. Retorna a função de cleanup. */
export function onAuthBroadcast(handler: (msg: AuthBroadcastMessage) => void): () => void {
  if (typeof BroadcastChannel === 'undefined') return () => {};
  const ch = new BroadcastChannel(CHANNEL);
  ch.onmessage = (e: MessageEvent<AuthBroadcastMessage>) => handler(e.data);
  return () => ch.close();
}
